import { Link } from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";
import styles from "./UnAuthorizedPage.module.css";

function UnAuthorizedPage() {
  usePageTitle();

  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <h1 className={styles.title}>Access restricted</h1>
        <p className={styles.body}>
          You do not have permission to view this page. Sign in with an account that has access, or return to the app home.
        </p>
        <p className={`${styles.body} ${styles.link}`}>
          <Link to="/login">Go to login</Link>
        </p>
      </div>
    </div>
  );
}

export default UnAuthorizedPage;
